// Shared constants for RTE components (JsonRTE and RichTextEditor)

export const INDENT_SIZE = 30 
export const MAX_INDENT_LEVEL = 20 

export const INDENT_EXCLUDED_TYPES = [
  'doc',
  'docs',
  'table',
  'thead',
  'tbody',
  'tr',
  'td',
  'th',
  'trgrp',
  'ol',
  'ul',
  'li'
]
